import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Layout from '../Layout';
import Dashboard from '../../../pages/Dashboard';
import Kanban from '../../../pages/Kanban';
import ProtectedRoute from '../Routs/ProtectedRoute';
import FormLayout from '../../../pages/Forms/FormLayout';
import DataTableBasic from '../../../pages/Tables/BasicTable';
import DataTablePagination from '../../../pages/Tables/DataTable';
import Profile from '../../../pages/UserManagement/profile';
//HR
import Designation from '../../../pages/HR/Designation/Designation';
import Department from '../../../pages/HR/Department/Department';
import Employee from '../../../pages/HR/Employee/Employee';
//client 
import Organization from '../../../pages/Client/Organization';
import Customer from '../../../pages/Client/Customer';
import MyCustomersPage from '../../../pages/Client/MyCustomers';
import CustomerUsersPage from '../../../pages/Client/CustomerUsers';
import TicketsPage from '../../../pages/Tickets';
import AdminTicketsPage from '../../../pages/Tickets/AdminTickets';
import AdminCreatedTicketsPage from '../../../pages/Tickets/AdminTickets/AdminCreatedTickets';
import TicketDetailsPage from '../../../pages/Tickets/Details';
import TicketSummaryReportPage from '../../../pages/Tickets/TicketsRepots/Tickets';
import TicketsSummaryReportPage from '../../../pages/Tickets/TicketsRepots/TicketsSummary';
import AdminAnalyticsDashboardPage from '../../../pages/Analytics_Reporting_Module_Tickets';
import DepartmentTaskAnalyticsPage from '../../../pages/Analytics_Reporting_Module_Tickets/DepartmentTaskAnalyticsPage';
import CustomerTicketAnalyticsPage from '../../../pages/Analytics_Reporting_Module_Tickets/CustomerTicketAnalyticsPage';
import AllTasksPage from '../../../pages/Tasks/AllTasksPage';
import AllTasksReportPage from '../../../pages/Tasks/AllTasksRepots';
import MyTasksDeskPage from '../../../pages/Tasks/MyTasks/MyTasksDeskPage';
import MyTasksPage from '../../../pages/Tasks/MyTasks/MyTasksPage';
import MyTaskObserversPage from '../../../pages/Tasks/MyTasks/MyTaskObserversPage';
import TaskReportPage from '../../../pages/Tasks/TasksRepot';
import TaskDetailsPage from '../../../pages/Tasks/TaskDetailsPage';
// userpermission
import UserModules from '../../../pages/UserManagement/UserModules';
import ModuleMenus from '../../../pages/UserManagement/ModuleMenus/ModuleMenus';
import DefultRoleMenuPermissions from '../../../pages/UserManagement/Permissions/DefultRoleMenuPermissions';
import UserMenuPermissions from '../../../pages/UserManagement/Permissions/UserMenuPermissions';
import UserMenuPermissionsByUserId from '../../../pages/UserManagement/Permissions/UserMenuPermissionsByUserId';
import Roles from '../../../pages/UserManagement/Roles';
import AllUser from '../../../pages/UserManagement/Permissions/AllUser';

const AuthRouts = () => {
  return (
    <Routes>
      <Route
        path="/client/organization"
        element={
          <ProtectedRoute>
            <Layout><Organization /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/client/customer"
        element={
          <ProtectedRoute>
            <Layout><Customer /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/client/my-customers"
        element={
          <ProtectedRoute>
            <Layout><MyCustomersPage /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/client/customer-users"
        element={
          <ProtectedRoute>
            <Layout><CustomerUsersPage /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/tickets"
        element={
          <ProtectedRoute>
            <Layout><TicketsPage /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/assigned-tickets"
        element={
          <ProtectedRoute>
            <Layout><TicketsPage /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/tickets/admin/new-request"
        element={
          <ProtectedRoute>
            <Layout><AdminTicketsPage /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/tickets/admin-created"
        element={
          <ProtectedRoute>
            <Layout><AdminCreatedTicketsPage /></Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/tickets/:id"
        element={
          <ProtectedRoute>
            <Layout><TicketDetailsPage /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/tickets/reports/tickets"
        element={
          <ProtectedRoute>
            <Layout><TicketSummaryReportPage /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/tickets/reports/tickets-summary"
        element={
          <ProtectedRoute>
            <Layout><TicketsSummaryReportPage /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/tickets/reports/admin-analytics"
        element={
          <ProtectedRoute>
            <Layout><AdminAnalyticsDashboardPage /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/reports/department-task-analytics"
        element={
          <ProtectedRoute>
            <Layout><DepartmentTaskAnalyticsPage /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/reports/customer-ticket-analytics"
        element={
          <ProtectedRoute>
            <Layout><CustomerTicketAnalyticsPage /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/tasks"
        element={
          <ProtectedRoute>
            <Layout><AllTasksPage /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/all-tasks"
        element={
          <ProtectedRoute>
            <Layout><AllTasksPage /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/my-tasks"
        element={
          <ProtectedRoute>
            <Layout><MyTasksDeskPage /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/task-history"
        element={
          <ProtectedRoute>
            <Layout><MyTasksPage /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/task-observers"
        element={
          <ProtectedRoute>
            <Layout><MyTaskObserversPage /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/task-report"
        element={
          <ProtectedRoute>
            <Layout><TaskReportPage /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/tasks/:taskId"
        element={
          <ProtectedRoute>
            <Layout><TaskDetailsPage /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/all-task-report"
        element={
          <ProtectedRoute>
            <Layout><AllTasksReportPage /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Layout><Dashboard /></Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/hr/department"
        element={
          <ProtectedRoute>
            <Layout><Department /></Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/hr/designation"
        element={
          <ProtectedRoute>
            <Layout><Designation /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/hr/employee"
        element={
          <ProtectedRoute>
            <Layout><Employee /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/user/modules"
        element={
          <ProtectedRoute>
            <Layout><UserModules /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/user/modules/menus"
        element={
          <ProtectedRoute>
            <Layout><ModuleMenus /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/defultrole/menu/permissions"
        element={
          <ProtectedRoute>
            <Layout><DefultRoleMenuPermissions /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/user/menu/permissions"
        element={
          <ProtectedRoute>
            <Layout><UserMenuPermissions /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/user/menu/permissions/:userId"
        element={
          <ProtectedRoute>
            <Layout><UserMenuPermissionsByUserId /></Layout>
          </ProtectedRoute>
        }
      />


      <Route
        path="/user/alluser"
        element={
          <ProtectedRoute>
            <Layout><AllUser /></Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/user/roles"
        element={
          <ProtectedRoute>
            <Layout><Roles /></Layout>
          </ProtectedRoute>
        }
      />


      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <Layout><Profile /></Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/kanban"
        element={
          <ProtectedRoute>
            <Layout><Kanban /></Layout>
          </ProtectedRoute>
        }
      />





      <Route
        path="/pages/form/layout"
        element={
          <ProtectedRoute>
            <Layout><FormLayout /></Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/pages/table/basic"
        element={
          <ProtectedRoute>
            <Layout><DataTableBasic /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/pages/dataTable/basic"
        element={
          <ProtectedRoute>
            <Layout><DataTablePagination /></Layout>
          </ProtectedRoute>
        }
      />




    </Routes>


  );
};

export default AuthRouts;
